module.exports = __webpack_public_path__ + "5a1a100f2dab7bddab65c97c8f1dd345.svg";